// Copyright (c) 2017 Deere & Company

import './product-search.scss';
import * as ProductSearchHelper from '../../shared/services/product-search-helper';
import {
    FormattedMessage,
    injectIntl,
    intlShape
} from 'react-intl';
import ProductSearchResult, {getDefaultState as getProductDefaultState} from '@deere/cps-it.warranty-model-factory/lib/product-search-results';
import React, {
    Component,
    PropTypes
} from 'react';
import {
    filterCollection,
    sortCollection
} from '../../../shared/services/collections';
import {
    getAllAvailableColumns,
    getAvailableColumns
} from '../../../shared/services/available-excel-columns';
import AccordionState from '../../../shared/components/smart-accordion/state/accordion';
import CreateClaimModal from '../../../shared/components/create-claim-modal';
import CreateClaimModalType from '../../../shared/state/create-claim-modal';
import DuplicatePinPlateLinkPanel from '../../shared/components/duplicate-pin-plate-link';
import ExcelLayoutModal from '../../../shared/components/excel-layout/excel-layout-modal';
import ExportToExcel from '../../../shared/state/export-to-excel';
import Facets from '../state/facets';
import HighRentalDays from './high-rental-days';
import Modal from '../../shared/state/modal';
import NonTrackedPinInfoBox from './non-tracked-pin-info-box';
import ProductList from './product-list';
import ProductReportLinks from '../../shared/components/product-report-links';
import ProductSearchBox from '../../shared/components/product-search-box';
import ProductsByCustomerLinkPanel from '../../shared/components/products-by-customer-link-panel';
import RefinableListWidgetWithExportAndLayouts from '../../../shared/components/refinable-list-widget/refinable-list-widget-with-export-and-layouts';
import SearchDropDown from '../../shared/state/search-by-dropdown';
import SearchFacets from './search-facets';
import SearchFilters from '../../shared/state/search-filters';
import Security from '@deere/cps-it.warranty-model-factory/lib/security';
import State from '../state';
import StatusChangeRequestModal from '../../shared/components/status-change-request-modal/status-change-request-modal';
import TabNavigation from '../../../shared/components/tab-navigation';
import User from '@deere/cps-it.warranty-model-factory/lib/user';
import WarrantyLoadingIndicator from '../../../shared/components/warranty-loading-indicator';
import {exportToExcel} from '../../../shared/services/export-to-excel';
import {getNavigationTabs} from '../../shared/services/product-navigation-helper';
import {getProductSearchColumns} from '../services/excel-columns';
import {getSortByList} from '../../../shared/services/get-excel-layout-modal-sort-by-list';
import {getStore} from '../../../store-factory';
import {hasAccess} from '../../../shared/services/security';
import {hasPermission} from '../../../shared/services/privacy';
import {isEntitled} from '../../../shared/services/entitlements';
import {pageSecurityWrapper} from '../../../shared/components/security-wrapper/page-security-wrapper';

function handleDealerFilterInput(text) {

    this.actions.updateProductSearchDealerFacetInput(text);

}

function toggleProductSearchDealerFacetItems() {

    this.actions.updateProductSearchDealerFacetItems(this.facets.dealerAccountsFacet.allowedDealers);

}

function toggleProductSearchDealerFacetItem(item, isSelected) {

    this.actions.updateProductSearchDealerFacetItem(item, isSelected);

}

function toggleProductSearchStatusFacetItems() {

    this.actions.updateProductSearchStatusFacetItems(this.facets.statusFacet.allowedStatuses);

}

function toggleProductSearchStatusFacetItem(item, isSelected) {

    this.actions.updateProductSearchStatusFacetItem(item, isSelected);

}

function updateRegisteredDateRangeFacet(registeredDates) {

    this.actions.updateRegisteredDateRangeFacet(registeredDates);

}

function resetProductSearchFacets() {

    this.actions.resetProductSearchFacets(this.facets.dealerAccountsFacet.allowedDealers, this.facets.statusFacet.allowedStatuses);

}

function openCreateClaimModal(pin) {

    this.actions.toggleCreateClaimModal(true, pin);

}

function closeCreateClaimModal() {

    this.actions.toggleCreateClaimModal(false);

}

function handleClick(key, pin) {

    this.actions.onCreateClaim(key, pin);

}

function handleSearch(query) {

    this.actions.onSearch(this.searchByDropDown.selectedOption.key, query);

}

function handleOpenStatusChangeModal(product) {

    this.actions.updateProduct(product);
    this.actions.updateStatusChangeModalVisibility('isVisible', true);

}

function handleUpdateStatus() {

    this.actions.updateStatusChangeModalVisibility('isVisible', false);
    this.actions.goToStatusChangeRequestView(this.product.pin);

}

function handleCloseStatusChangeModal() {

    this.actions.updateStatusChangeModalVisibility('isVisible', false);

}

function handleAccordionToggle() {

    this.actions.toggleReportsAccordion();

}

function handleCreateExcelLayout() {

    const availableColumns = getAllAvailableColumns('productSearch');

    this.actions.updateExcelLayoutModalExcelLayout(true);
    this.actions.updateExcelLayoutModalIsNewLayout(true, 'productSearch');
    this.actions.updateExcelLayoutModalAvailableColumns(availableColumns);

    if (!this.exportToExcel.excelLayouts.productSearch.length) {

        this.actions.updateExcelLayoutModalExcelLayoutIsDefault(true);

    }

    this.actions.updateExcelLayoutModalVisibility(true);

}

function handleEditExcelLayout() {

    const availableColumns = getAvailableColumns('productSearch', this.exportToExcel.selectedExcelLayout.productSearch.columns);

    this.actions.updateExcelLayoutModalExcelLayout(false, this.exportToExcel.selectedExcelLayout.productSearch);
    this.actions.updateExcelLayoutModalIsNewLayout(false, 'productSearch');
    this.actions.updateExcelLayoutModalAvailableColumns(availableColumns);
    this.actions.updateExcelLayoutModalVisibility(true);

}

function handleExcelLayoutChange(selectedLayout) {

    const availableColumns = getAvailableColumns('productSearch', selectedLayout.columns);

    this.actions.updateSelectedExcelLayout(selectedLayout, 'productSearch');
    this.actions.updateExcelLayoutModalExcelLayout(false, selectedLayout);
    this.actions.updateExcelLayoutModalAvailableColumns(availableColumns);

}

function handleColumnMove(dragIndex, hoverIndex, listId, dragCard) {

    listId === 'available-items' ?
        this.actions.updateExcelLayoutModalAvailableColumnsOrder(dragIndex, hoverIndex, dragCard) :
        this.actions.updateExcelLayoutModalExcelLayoutColumnsOrder(dragIndex, hoverIndex, dragCard);

}

function handleColumnPush(column, sourceListId) {

    sourceListId === 'available-items' ?
        this.actions.pushExcelLayoutModalExcelLayoutColumn(column) :
        this.actions.pushExcelLayoutModalAvailableColumn(column);

}

function handleColumnRemove(index, sourceListId) {

    sourceListId === 'available-items' ?
        this.actions.removeExcelLayoutModalAvailableColumn(index) :
        this.actions.removeExcelLayoutModalExcelLayoutColumn(index);

}

function handleExcelLayoutDelete() {

    this.actions.deleteExcelLayout(this.exportToExcel.selectedExcelLayout.productSearch.name, this.exportToExcel.selectedExcelLayout.productSearch.listId, 'productSearch');

}

function handleLayoutNameBlur(layoutName) {

    const nameAlreadyExists = this.exportToExcel.excelLayouts.productSearch.some(layout => layout.name === layoutName);

    nameAlreadyExists ?
        this.actions.updateExcelLayoutModalIsNameValid(false) :
        this.actions.updateExcelLayoutModalIsNameValid(true);

}

function handleLayoutNameChange(layoutName) {

    this.actions.updateExcelLayoutModalLayoutName(layoutName);

}

function handleExcelLayoutModalClose() {

    this.actions.updateExcelLayoutModalVisibility(false);
    this.actions.updateExcelLayoutModalIsNameValid(true);

}

function handleSaveExcelLayout() {

    this.actions.saveExcelLayout(this.exportToExcel.excelLayoutModal.excelLayout, 'productSearch');

}

function handleSetAsDefaultChange(isSelected) {

    this.actions.updateExcelLayoutModalExcelLayoutIsDefault(isSelected);

}

function handleSortByChange(sortByColumn) {

    this.actions.updateExcelLayoutModalExcelLayoutSortBy(sortByColumn, this.exportToExcel.excelLayoutModal.excelLayout.sortBy);

}

function handleSortDirectionChange(sortDirection) {

    this.actions.updateExcelLayoutModalExcelLayoutSortDirection(sortDirection, this.exportToExcel.excelLayoutModal.excelLayout.sortBy);

}

function handleHighRentalDaysDownloadToExcel() {

    this.actions.highRentalDaysExportToExcel(
        this.user.settings,
        this.user.getLocale()
    );

}

class ProductSearch extends Component {

    componentWillMount() {

        if (!this.props.facets.statusFacet.allowedStatuses.length) {

            this.props.actions.getProductSearchStatus();

        }

        this.props.actions.getClaimTypeList();
        this.props.actions.highOnRentalDays(this.props.user.settings);

        if (this.props.facets.dealerAccountsFacet.isInitialLoad) {

            this.props.actions.selectAllDealersOnInitialLoad(this.props.facets.dealerAccountsFacet.allowedDealers);

        }

        if (this.props.queryParams.q && this.props.queryParams.by) {

            this.props.actions.updateSearchQueryString(this.props.queryParams.q);
            this.props.actions.updateSearchDropDown(this.props.queryParams.by);
            this.props.actions.updateSearchResults(this.props.queryParams.q, this.props.queryParams.by);
            this.props.actions.updateRegistrationResults(this.props.facets.dealerAccountsFacet.isInitialLoad);

        }

    }

    componentWillReceiveProps(nextProps) {

        const newSearch = (nextProps.queryParams.by && nextProps.queryParams.q) && (this.props.queryParams.by !== nextProps.queryParams.by || this.props.queryParams.q !== nextProps.queryParams.q);

        if (newSearch) {

            this.props.actions.updateSearchQueryString(nextProps.queryParams.q);
            this.props.actions.updateSearchDropDown(nextProps.queryParams.by);
            this.props.actions.updateSearchResults(nextProps.queryParams.q, nextProps.queryParams.by);

        }

    }

    componentWillUnmount() {

        this.props.actions.toggleCreateClaimModal(false);
        this.props.actions.updateProduct(getProductDefaultState());
        this.props.actions.updateStatusChangeModalVisibility('isVisible', false);
        this.props.actions.resetExportToExcelLayout();

    }

    render() {

        const countObject = {
            dealerRecommendations: this.props.dealerRecommendationCount,
            machineStatusUpdates: this.props.machineStatusUpdateCount,
            productSearch: this.props.filteredSearchResults.length,
            registrationReview: this.props.registrationReviewCount,
            transferApproval: this.props.transferApprovalsCount
        };

        let sortedCollection;

        sortedCollection = [...this.props.filteredSearchResults];
        sortedCollection = sortCollection(this.props.searchFilters.sortBy, this.props.searchFilters.sortDirection, sortedCollection);
        sortedCollection = filterCollection(this.props.searchFilters.filterBy, ProductSearchHelper.getFilterOptions(), sortedCollection);

        return (
            <div className='product-search'>
                <WarrantyLoadingIndicator isLoading={this.props.busyCounter > 0}/>
                <aside>
                    <SearchFacets
                        dateFormat={this.props.dateFormat}
                        dealerAccountsFacet={this.props.facets.dealerAccountsFacet}
                        onApply={this.props.actions.applySearchFilters}
                        onDatePickerChange={this.props::updateRegisteredDateRangeFacet}
                        onDealerInputChange={this.props::handleDealerFilterInput}
                        onDealerItemChange={this.props::toggleProductSearchDealerFacetItem}
                        onDealerItemsChange={this.props::toggleProductSearchDealerFacetItems}
                        onReset={this.props:: resetProductSearchFacets}
                        onStatusItemChange={this.props::toggleProductSearchStatusFacetItem}
                        onStatusItemsChange={this.props::toggleProductSearchStatusFacetItems}
                        registeredDateRange={this.props.facets.registeredDateRange}
                        statusFacet={this.props.facets.statusFacet}
                    />
                    <HighRentalDays
                        highRentalDaysCount={this.props.highRentalDaysCount}
                        onExport={this.props::handleHighRentalDaysDownloadToExcel}
                    />
                    {!this.props.user.privacy.customerPrivate &&
                        <ProductsByCustomerLinkPanel/>
                    }
                    {isEntitled(getStore().getState().user.entitlements, 'duplicatepins') > 0 &&
                    <DuplicatePinPlateLinkPanel/>
                    }
                    <div className='report-links'>
                        <ProductReportLinks
                            onAccordionToggle={this.props::handleAccordionToggle}
                            reportsAccordion={this.props.reportsAccordion}
                            reportsRoutes={this.props.reportsRoutes}
                        />
                    </div>
                </aside>
                <main>
                    <div className='primary-actions'>
                        {hasAccess(this.props.security, 'PRT', 'PRT_REGISTER_PRODUCT') && hasPermission(this.props.user.privacy, 'registrationNotAllowed') &&
                            <a
                                className='primary-action'
                                href={'#/products/register-product'}
                            >
                                <FormattedMessage id='REGISTER_PRODUCT'/>
                            </a>
                        }
                    </div>
                    <ProductSearchBox
                        handleSearch={this.props::handleSearch}
                        searchByDropDown={this.props.searchByDropDown}
                        searchQueryString={this.props.searchQueryString}
                        updateSearchDropDown={this.props.actions.updateSearchDropDown}
                        updateSearchQueryString={this.props.actions.updateSearchQueryString}
                    />
                    <TabNavigation
                        tabs={getNavigationTabs(countObject, true, this.props.security)}
                    />
                    {this.props.searchResults.length === 1 && this.props.searchResults[0].isNonTracked ?
                        <NonTrackedPinInfoBox pin={this.props.searchResults[0].pin}/> :
                        <ProductList
                            onClaimsModalOpen={this.props::openCreateClaimModal}
                            onOpenStatusChangeModal={this.props::handleOpenStatusChangeModal}
                            products={sortedCollection}
                        >
                            <RefinableListWidgetWithExportAndLayouts
                                excelLayouts={this.props.exportToExcel.excelLayouts.productSearch}
                                onCreateLayout={this.props::handleCreateExcelLayout}
                                onEditLayout={this.props::handleEditExcelLayout}
                                onExport={() => exportToExcel(`/api/products/search?by=${this.props.searchByDropDown.selectedOption.key}&q=${this.props.searchQueryString}&export=EXCEL&language=${this.props.user.getLocale()}&layout=${encodeURIComponent(this.props.exportToExcel.selectedExcelLayout.productSearch.name)}&listId=productSearch`)}
                                onFilterByChange={this.props.actions.updateListFilterBy}
                                onLayoutChange={this.props::handleExcelLayoutChange}
                                onSortByChange={this.props.actions.updateListSortBy}
                                onSortDirectionChange={this.props.actions.updateListSortDirection}
                                searchFilters={this.props.searchFilters}
                                selectedLayout={this.props.exportToExcel.selectedExcelLayout.productSearch}
                                sortOptions={ProductSearchHelper.getSortOptions()}
                                type={State}
                            />
                        </ProductList>
                    }
                    <CreateClaimModal
                        claimTypes={this.props.createClaimModal.claimTypes}
                        isModalOpen={this.props.createClaimModal.isModalOpen}
                        onClick={this.props::handleClick}
                        onCloseButtonClick={this.props::closeCreateClaimModal}
                        selectedPin={this.props.createClaimModal.selectedPin}
                    />
                    <StatusChangeRequestModal
                        changeModalVisibility={this.props::handleCloseStatusChangeModal}
                        product={this.props.product}
                        productStatusChangeModal={this.props.statusChangeModal}
                        updateStatus={this.props::handleUpdateStatus}
                    />
                    <ExcelLayoutModal
                        excelLayoutModal={this.props.exportToExcel.excelLayoutModal}
                        mappingTable={getProductSearchColumns().listColumns}
                        onColumnMove={this.props::handleColumnMove}
                        onColumnPush={this.props::handleColumnPush}
                        onColumnRemove={this.props::handleColumnRemove}
                        onLayoutDelete={this.props::handleExcelLayoutDelete}
                        onLayoutNameBlur={this.props::handleLayoutNameBlur}
                        onLayoutNameChange={this.props::handleLayoutNameChange}
                        onModalClose={this.props::handleExcelLayoutModalClose}
                        onSaveLayout={this.props::handleSaveExcelLayout}
                        onSetAsDefaultChange={this.props::handleSetAsDefaultChange}
                        onSortByChange={this.props::handleSortByChange}
                        onSortDirectionChange={this.props::handleSortDirectionChange}
                        sortByList={getSortByList(getProductSearchColumns().listColumns, this.props.exportToExcel.excelLayoutModal.excelLayout.columns)}
                    />
                </main>
            </div>
        );

    }

}

ProductSearch.displayName = 'ProductSearch';
ProductSearch.propTypes = {
    actions: PropTypes.object.isRequired,
    busyCounter: PropTypes.number.isRequired,
    createClaimModal: PropTypes.instanceOf(CreateClaimModalType).isRequired,
    dateFormat: PropTypes.string.isRequired,
    dealerRecommendationCount: PropTypes.number,
    exportToExcel: PropTypes.instanceOf(ExportToExcel).isRequired,
    facets: PropTypes.instanceOf(Facets).isRequired,
    filteredSearchResults: PropTypes.arrayOf(PropTypes.instanceOf(ProductSearchResult)).isRequired,
    highRentalDaysCount: PropTypes.number.isRequired,
    intl: intlShape.isRequired,
    machineStatusUpdateCount: PropTypes.number,
    product: PropTypes.instanceOf(ProductSearchResult).isRequired,
    queryParams: PropTypes.object.isRequired,
    registrationReviewCount: PropTypes.number.isRequired,
    reportsAccordion: PropTypes.instanceOf(AccordionState).isRequired,
    reportsRoutes: PropTypes.object.isRequired,
    searchByDropDown: PropTypes.instanceOf(SearchDropDown).isRequired,
    searchFilters: PropTypes.instanceOf(SearchFilters).isRequired,
    searchQueryString: PropTypes.string.isRequired,
    searchResults: PropTypes.arrayOf(PropTypes.instanceOf(ProductSearchResult)).isRequired,
    security: PropTypes.instanceOf(Security).isRequired,
    statusChangeModal: PropTypes.instanceOf(Modal).isRequired,
    transferApprovalsCount: PropTypes.number.isRequired,
    user: PropTypes.instanceOf(User).isRequired
};

export default pageSecurityWrapper('PRT', 'PRT_PRODUCT_SEARCH')(injectIntl(ProductSearch));



// WEBPACK FOOTER //
// ./src/product/search/components/product-search.js